var React = require('react');

function IconPauseInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"i0"},React.createElement("path",{"d":"M4,0 C4.55228475,-1.01453063e-16 5,0.44771525 5,1 L5,15 C5,15.5522847 4.55228475,16 4,16 L1,16 C0.44771525,16 6.76353751e-17,15.5522847 0,15 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L4,0 Z M12,0 C12.5522847,-1.01453063e-16 13,0.44771525 13,1 L13,15 C13,15.5522847 12.5522847,16 12,16 L9,16 C8.44771525,16 8,15.5522847 8,15 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 L12,0 Z"}))),React.createElement("g",{"transform":"translate(3.5 2.0)","key":1},React.createElement("g",{"clipPath":"url(#i0)"},React.createElement("polygon",{"points":"0,0 13,0 13,16 0,16 0,0","stroke":"none","fill":"#000000"})))]);
}

IconPauseInline.defaultProps = {"version":"1.1","width":"20px","height":"20px","viewBox":"0 0 20.0 20.0"};

module.exports = IconPauseInline;

IconPauseInline.default = IconPauseInline;
